// extracted by mini-css-extract-plugin
export default {"wrapper":"SavedSearches_wrapper__ecD1q"};